require('./_wks-define')('asyncIterator');



//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/modules/es7.symbol.async-iterator.js
// module id = 629
// module chunks = 95715928098905 168707334958949